import {BoxProps} from "@mui/material"
import {FC} from "react"
import {makeStyles} from "tss-react/mui";
import type {IModuleScheduled} from "@buildwitt/shapeshift-types";
import {Link, useMatch} from "react-router-dom";
import {ModuleSummaryCard} from "../../../components/module/ModuleSummaryCard";
import {palette} from "../../../constants";

interface IProps extends BoxProps {
	module: IModuleScheduled
}

const useStyles = makeStyles<{pageIsActive: boolean}>()((theme, {pageIsActive}) => ({
	trainingFeedModule: {
		outline: "1px solid " + (pageIsActive ? theme.palette.primary.main : palette.grey05)
	}
}));


export const TrainingFeedAnnouncementSlim:FC<IProps> = ({className, module, ...boxProps}) => {
	const url = "/feed/announcement/" + module.slug;
	const pageIsActive = useMatch(url);
	const {classes, cx} = useStyles({pageIsActive: !!pageIsActive});

	return (
		<Link to={url} style={{width: "100%"}}>
			<ModuleSummaryCard module={module} className={cx(classes.trainingFeedModule, className)} {...boxProps}/>
		</Link>
	)
}